import React from 'react';
import { ShieldCheck, AlertTriangle } from 'lucide-react';

/**
 * Badges de status com cores fixas e reservadas por significado:
 * - selo verde: somente verificado/registrado/ativo
 * - cinza: rascunho/pendente
 * - vermelho: somente expirado/erro
 */
const STYLES = {
  registered: { className: 'badge-verified', label: 'Registrado', Icon: ShieldCheck },
  verified: { className: 'badge-verified', label: 'Verificado', Icon: ShieldCheck },
  active: { className: 'badge-verified', label: 'Ativo', Icon: ShieldCheck },
  draft: { className: 'badge-draft', label: 'Rascunho', Icon: null },
  pending: { className: 'badge-draft', label: 'Pendente', Icon: null },
  expired: { className: 'badge-error', label: 'Expirado', Icon: AlertTriangle },
  error: { className: 'badge-error', label: 'Erro', Icon: AlertTriangle },
};

const StatusBadge = ({ status = 'draft', label, className = '' }) => {
  const style = STYLES[status] || STYLES.draft;
  const { Icon } = style;
  return (
    <span className={`${style.className} ${className}`}>
      {Icon && <Icon className="w-3 h-3" aria-hidden="true" />}
      {label || style.label}
    </span>
  );
};

export default StatusBadge;
